// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__I38mO","error":"Textarea_error__2qf7a","readonly":"Textarea_readonly__17s06","disabled":"Textarea_disabled__1CXC3"};